<script setup lang="ts">

import { ref, onMounted, defineProps } from 'vue'
import { useGameStore } from '@/stores/gameStore'
import ModalCloseButton from '@/components/Elements/Buttons/ModalCloseButton.vue'

const props = defineProps({
  title: String
});

const gameStore = useGameStore()
const visible = ref(false)

onMounted(() => {
  visible.value = true
})

const closeModal = () => {
  visible.value = false
  setTimeout(() => {
    gameStore.modalType = ''
  }, 150)
}

window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeModal()
  }
})

</script>

<template>
  <div
      class="fixed w-full h-full top-0 left-0 z-30 modal-safe-area backdrop-transition"
      :class="visible ? 'bg-black/40 backdrop-blur-sm' : 'bg-transparent backdrop-blur-none'"
      @click="closeModal()">
    <div
        class="flex overflow-x-hidden  justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full mx-auto model-width-lg">
      <Transition name="modal">
        <div v-if="visible" class="relative p-1 md:p-3  w-full max-w-4xl max-h-full" @click.prevent.stop>
          <div class="relative rounded-lg bg-metal-950 border border-metal-800">
            <div class="flex items-center justify-between p-3 md:p-3 rounded-t modal-header">
              <h3 class="text-metal-300 text-base">
                {{ props.title }}
              </h3>
              <ModalCloseButton @click.stop="closeModal">X</ModalCloseButton>
            </div>
            <div class="border-l border-r border-b border-metal-900 rounded-b-lg">
              <slot></slot>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </div>

</template>



<style scoped lang="scss">
/* iOS-specific safe area insets - only apply on iOS devices to avoid Android issues */
@supports (-webkit-touch-callout: none) {
  .modal-safe-area {
    padding-top: env(safe-area-inset-top);
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
}

.modal-header {
  background: linear-gradient(to right, theme('colors.metal.800'), theme('colors.metal.900'));
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 150ms ease, transform 150ms ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.backdrop-transition {
  transition: background-color 150ms ease, backdrop-filter 150ms ease;
}
</style>
